import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_HOST;


export const getMenu = async ({   limit = 10  , page = 1}) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/menu`, {
    params: { limit , page },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });


  const resData = response.data.data;
  return {
    data : resData,
    currentPage: resData.current_page,
    lastPage: resData.last_page,
    perPage: resData.per_page,
    total: resData.total,
    nextPageUrl: resData.next_page_url,
    prevPageUrl: resData.first_page_url,
  };
};

export const addMenu = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/menu/add`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getMenuById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/menu/show/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const updateMenu = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/menu/update`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const deleteMenuById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/menu/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


